import { RouteConfig } from "vue-router";

export const RExpertInvites: RouteConfig = {
  path: "invites",
  component: () =>
    import(
      /* webpackChunkName: "expert-invites" */
      "./VExpertInvites.vue"
    ),
  meta: {
    title: "Invites",
    icon: "person-add-outline",
    newIcon: "circle-check",
  },
};
